import { fromJS, List, Map } from 'immutable';
import { Delta, PushEvent } from '../../../dto/PushEnvelope';
import { Tournament } from '../../../dto';
import {
    createOrderedIndex,
    indexById,
    insertToOrderedIndex,
    mergeOrderedIndex,
    removeFromOrderedIndex,
    updateIndexedById
} from '../../indexingUtils';

export function onTournamentsSnapshot(tournaments: Tournament[]) {
    return (db: Map<string, any>) =>
        db
            .setIn(['tournaments'], indexById(tournaments))
            .setIn(['tournamentIdsByOrder'], createOrderedIndex(tournaments, 'order'));
}

export function onTournamentsSnapshotMerge(tournaments: Tournament[]) {
    return (db: Map<string, any>) =>
        db
            .mergeIn(['tournaments'], Map(), indexById(tournaments))
            .updateIn(['tournamentIdsByOrder'], List(), ids =>
                mergeOrderedIndex(ids, createOrderedIndex(tournaments, 'order'))
            );
}

export function onTournamentPush(event: PushEvent, data: Tournament | Delta | { id: string }) {
    switch (event) {
        case PushEvent.CREATED:
            return onCreated(data as Tournament);
        case PushEvent.UPDATED:
            return updateIndexedById(data as Delta, 'tournaments');
        case PushEvent.DELETED:
            return onDeleted(data.id);
        default:
            console.error(`Invalid PushEvent ${event}`);
            return turboLiveDb => turboLiveDb;
    }
}

export function onCreated(tournament: Tournament) {
    return turboLiveDb => {
        const { id, order } = tournament;

        return turboLiveDb
            .update('tournaments', tournaments => tournaments.set(id, fromJS(tournament)))
            .update('tournamentIdsByOrder', List(), insertToOrderedIndex({ id, order }));
    };
}

export function onDeleted(tournamentId: string) {
    return turboLiveDb =>
        turboLiveDb
            .update('tournaments', tournaments => tournaments.delete(tournamentId))
            .update('tournamentIdsByOrder', List(), removeFromOrderedIndex(tournamentId));
}
